import i18n from '@/i18n';

export const INDEX_OPTION_MENU = {
  CREDIT_CART: 0,
  BILLET: 1,
  PIX: 2
};

export const PAYMENT_METHODS = [
  {
    id: INDEX_OPTION_MENU.CREDIT_CART,
    name: i18n.t('folderConstants.paymentMethods.creditCard.name').toString(),
    discount: null,
    colorDiscount: null,
    icon: 'CreditCard',
    active: true
  },
  {
    id: INDEX_OPTION_MENU.BILLET,
    name: i18n.t('folderConstants.paymentMethods.billet.name').toString(),
    discount: i18n.t('folderConstants.paymentMethods.billet.discount').toString(),
    colorDiscount: '#E8219F',
    icon: 'Billet',
    active: false
  },
  {
    id: INDEX_OPTION_MENU.PIX,
    name: i18n.t('folderConstants.paymentMethods.pix.name').toString(),
    discount: i18n.t('folderConstants.paymentMethods.pix.discount').toString(),
    colorDiscount: '#E82145',
    icon: 'Pix',
    active: false
  }
];

export const TYPE_DISCOUNT = {
  CREDIT_CART: 'credit_card',
  PIX: 'pix',
  BILLET: 'bank_slip'
};

export const METHOD_PAYMENT = {
  [INDEX_OPTION_MENU.CREDIT_CART]: TYPE_DISCOUNT.CREDIT_CART,
  [INDEX_OPTION_MENU.PIX]: TYPE_DISCOUNT.PIX,
  [INDEX_OPTION_MENU.BILLET]: TYPE_DISCOUNT.BILLET
};

export const METHOD_PAYMENT_TITLE = {
  [INDEX_OPTION_MENU.CREDIT_CART]: i18n.t('folderConstants.methodPaymentTitle.creditCard').toString(),
  [INDEX_OPTION_MENU.PIX]: i18n.t('folderConstants.methodPaymentTitle.pix').toString(),
  [INDEX_OPTION_MENU.BILLET]: i18n.t('folderConstants.methodPaymentTitle.billet').toString()
};

export const METHOD_PAYMENT_NAME = {
  [TYPE_DISCOUNT.CREDIT_CART]: i18n.t('folderConstants.methodPaymentName.creditCard').toString(),
  [TYPE_DISCOUNT.PIX]: i18n.t('folderConstants.methodPaymentName.pix').toString(),
  [TYPE_DISCOUNT.BILLET]: i18n.t('folderConstants.methodPaymentName.billet').toString()
};

export const METHOD_BY_CREDIT_CART = 'credit_card';
export const METHOD_BY_BILLET = 'bank_slip';
export const METHOD_BY_PIX = 'pix';

export const INTERVAL_MONTHLY = 1;

export const LIST_INTERVAL = [
  {
    title: i18n.t('folderConstants.listInterval.annual').toString(),
    value: 12
  },
  {
    title: i18n.t('folderConstants.listInterval.semester').toString(),
    value: 6
  },
  {
    title: i18n.t('folderConstants.listInterval.quarterly').toString(),
    value: 3
  },
  {
    title: i18n.t('folderConstants.listInterval.monthly').toString(),
    value: 1
  }
];

export const PLAN_TYPE_ANNUAL = 12;
export const PLAN_TYPE_SEMIANNUAL = 6;

export const PAYMENT_STATUS = {
  PENDING: 'pending',
  CANCELED: 'canceled',
  PAID: 'paid',
  CREATED: 'created'
};

export const PHYSICAL_PRODUCT_ID = 101;

export const PLAN_TYPE: Record<number, string> = {
  12: i18n.t('folderConstants.planType.annual').toString(),
  6: i18n.t('folderConstants.planType.semester').toString(),
  3: i18n.t('folderConstants.planType.quarterly').toString(),
  1: i18n.t('folderConstants.planType.monthly').toString()
};
